import { render, staticRenderFns } from "./MonriPay.vue?vue&type=template&id=2217219f&scoped=true&"
import script from "./MonriPay.vue?vue&type=script&lang=js&"
export * from "./MonriPay.vue?vue&type=script&lang=js&"
import style0 from "./MonriPay.vue?vue&type=style&index=0&id=2217219f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2217219f",
  null
  
)

export default component.exports